import * as R from 'ramda';
import React, { useEffect, useState } from 'react';
// helpers/constants
import * as G from '../helpers';
import * as GC from '../constants';
// utilities
import { sendRequest } from '../utilities/http';
import endpointsMap from '../utilities/endpoints';
//////////////////////////////////////////////////

const useAsyncStatusMessages = (branchGuid) => {
  const [statusMessagesConfigs, setStatusMessagesConfigs] = useState(null);

  useEffect(() => {
    const getStatusConfigsRequest = async () => {
      if (G.isNilOrEmpty(branchGuid)) return;

      const params = { [GC.FIELD_BRANCH_GUID]: branchGuid };

      const res = await sendRequest('get', endpointsMap.statusCodeList, { params });

      const { data, status } = res;

      if (G.isResponseSuccess(status)) {
        if (G.isNotEmpty(data)) {
          setStatusMessagesConfigs(data);
        }
      } else {
        G.handleFailResponseSimple(
          res,
          false,
          'withAsyncStatusMessages -> getStatusConfigsRequest',
        );
      }
    };

    getStatusConfigsRequest();
  }, []);

  return statusMessagesConfigs;
};

export const withAsyncStatusMessages = (Component) => (props) => {
  const { branchGuid } = props;

  const statusMessagesConfigs = useAsyncStatusMessages(branchGuid);

  return <Component {...props} statusMessagesConfigs={statusMessagesConfigs} />;
};
